import { useCallback, useEffect } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setEnableResetPasswordMethods } from "@/domains/auth/slice";

export default function useGetEnableTfaMethods() {
  const dispatch = useAppDispatch();

  const getData = useCallback(async () => {
    try {
      const response = await AccountMpProvider.getEnableTfaMethods();
      const methods: TfaMethod[] = [TfaMethod.EMAIL];
      if (response instanceof RpcMpProviderSuccessResponse) {
        if (response.data.isTwoFactorGoogleEnabled) {
          methods.push(TfaMethod.AUTHENTICATOR);
        }
        if (response.data.isTwoFactorSmsEnabled) {
          methods.push(TfaMethod.SMS);
        }
      }
      dispatch(setEnableResetPasswordMethods(methods));
    } catch (e) {
      // TODO: ....
    }
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);
}
